import { gql } from '@apollo/client';

export const GET_PRODUCT_TYPES = gql`
  query {
    listProductTypes {
      id
      name
      disclaimer
      dynamicFields
      disclaimerByLanguage
    }
  }
`;

export const ADD_PRODUCT_TYPE = gql`
  mutation createProductType(
    $name: String!
    $disclaimer: String
    $dynamicFields: String
    $disclaimerByLanguage: String
  ) {
    createProductType(
      input: {
        name: $name
        disclaimer: $disclaimer
        dynamicFields: $dynamicFields
        disclaimerByLanguage: $disclaimerByLanguage
      }
    ) {
      id
      name
      disclaimer
      dynamicFields
    }
  }
`;

export const EDIT_PRODUCT_TYPE = gql`
  mutation updateProductType(
    $id: String!
    $name: String!
    $disclaimer: String
    $dynamicFields: String
    $disclaimerByLanguage: String
  ) {
    updateProductType(
      id: $id
      input: {
        name: $name
        disclaimer: $disclaimer
        dynamicFields: $dynamicFields
        disclaimerByLanguage: $disclaimerByLanguage
      }
    ) {
      id
      name
      disclaimer
      dynamicFields
      disclaimerByLanguage
    }
  }
`;

export const DELETE_PRODUCT_TYPE = gql`
  mutation deleteProductType($id: String!) {
    deleteProductType(id: $id) {
      id
      name
      disclaimer
    }
  }
`;
